import React from 'react';
import PropTypes from 'prop-types';
import SearchField from '.';

const FormikSearchField = ({
  field: { name, value },
  form: { setFieldValue },
  onInputTextChange,
  id,
  label,
  className,
  onChange,
  options,
  isLoading,
  minSearchCharsLength,
  linkTypeOptions,
  placeholder,
  onEnter,
  onFocus,
  resetOptions,
}) => (
  <SearchField
    label={label}
    name={name}
    id={id}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    onInputTextChange={onInputTextChange}
    setField={newValue => setFieldValue(name, newValue)}
    className={className}
    options={options}
    loading={isLoading}
    minSearchCharsLength={minSearchCharsLength}
    linkTypeOptions={linkTypeOptions}
    onEnter={onEnter}
    onFocus={onFocus}
    onBlur={resetOptions}
    isMainArtistSearchFilter
  />
);

FormikSearchField.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  minSearchCharsLength: PropTypes.number,
  options: PropTypes.array,
  onInputTextChange: PropTypes.func,
  onChange: PropTypes.func,
  onEnter: PropTypes.func,
  isLoading: PropTypes.bool,
  linkTypeOptions: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array, PropTypes.object]),
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
  }),
  isMainArtistSearchFilter: PropTypes.bool,
};

FormikSearchField.defaultProps = {
  onChange: () => {},
  className: '',
  placeholder: '',
  linkTypeOptions: true,
  minSearchCharsLength: 1,
  isLoading: false,
  form: {
    setFieldValue: () => {},
  },
};

export default FormikSearchField;
